import { cn } from '@heidi/utils';

/**
 * Lets a FormLabel take the toggle states wherever it sits in the row.
 * `[id$=-form-item]` is the FormControl target (what FormLabel's `for` points
 * at), so a radio group's heading never gets a pointer. A FormItem holding
 * other FormItems (a checkbox group) opts out, or `:has()` would style its
 * heading and every option from any one option's toggle.
 */
export const formItemClasses = 'group/form-item flex flex-col gap-1';

export const formLabelToggleStateClasses = cn(
  'group-[:has([id$=-form-item]:is([role=switch],[role=checkbox]):disabled):not(:has([data-slot=form-item]))]/form-item:opacity-70',
  'group-[:has([id$=-form-item]:is([role=switch],[role=checkbox]):enabled):not(:has([data-slot=form-item]))]/form-item:cursor-pointer',
  'group-[:has([id$=-form-item]:is([role=switch],[role=checkbox]):disabled):not(:has([data-slot=form-item]))]/form-item:cursor-not-allowed'
);

/** Dims with its label, like Label's own description. */
export const formDescriptionToggleStateClasses =
  'group-[:has([id$=-form-item]:is([role=switch],[role=checkbox]):disabled):not(:has([data-slot=form-item]))]/form-item:opacity-70';
